// Module
var code = "<div id=\"V-7293EB83-29C5-4A35-B35B-9353AB0AB45F\"> <div data-b-component=\"grid\" data-b-event-dblclick=\"{Binding doubleClick}\"> <select></select> </div> </div> ";
// Exports
export default code;